<template>
  <div class="relative" @click="clickAuthBtn">
    <slot />

    <div
      v-if="showLock"
      class="absolute top-0 right-0 translate-x-1/2 -translate-y-1/3 text-xs scale-75 pointer-events-none"
    >
      <i v-if="showAuthLock" class="iconify mdi--lock text-primary" />
      <!-- <i v-else class="iconify mdi--lock-off text-green-500"></i> -->
    </div>
  </div>
</template>

<script setup lang="ts">
import { useGlobalUser } from "@/stores/globalUser";
import { computed } from "vue";

const props = defineProps({
  type: {
    type: Number,
    default: 3,
  },
  showLock: {
    type: Boolean,
    default: true,
  },
});

const userStore = useGlobalUser();

const showAuthLock = computed(
  () =>
    userStore.user.subscriptionType < props.type &&
    (userStore.user.dtSubscriptionTrialEnd === null ||
      new Date(userStore.user.dtSubscriptionTrialEnd) < new Date())
);

const clickAuthBtn = () =>
  showAuthLock.value && userStore.updateCurrentMateId();
</script>
